<template>
  <TachographFiles />
</template>

<script lang="ts">
import { defineComponent, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import TachographFiles from '@/components/content/TachographFiles.vue'

export default defineComponent({
  name: 'TachographFilesView',
  components: { TachographFiles },
  setup(props, context) {
    const i18n = useI18n()

    context.emit('pageName', i18n.t('aside.menu.pages.tachographFiles'))

    watch(() => i18n.locale.value, () => {
      context.emit('pageName', i18n.t('aside.menu.pages.tachographFiles'))
    })
  }
})
</script>